export default __webpack_public_path__ + "static/media/appTopBar.b0d245b0.png";